import bus from "../services/bus"

let serviceWorker

export default {
  data() {
    return {
      visible: false,
    }
  },

  mounted() {
    bus.$on("sw:updated", this.swUpdated)
  },

  methods: {
    close() {
      this.visible = false
    },

    swUpdated(worker) {
      serviceWorker = worker
      this.visible = true
    },

    reload() {
      serviceWorker.postMessage({ type: "SKIP_WAITING" })
      window.location.reload()
    },
  },

  destroyed() {
    bus.$off("sw:updated", this.swUpdated)
  },
}
